const INTUIT_APIKEY = window.__shellInternal?.appExperience?.appApiKey || '';
const CSRF_TOKEN =
  window.__shellInternal?.pluginsInfo?.plugins['mc-monolith-plugin']
    ?.extendedProperties?.e2eCSRFToken || '';

export const APP_FABRIC_CONFIG = {
  proxyBaseUrl: 'https://mc-appfabricproxy-e2e.api.intuit.com',
  proxyDefaultOptions: {
    mode: 'cors',
    credentials: 'include',
    redirect: 'follow',
  },

  // Dynamic values needed for request headers for Proxy
  intuit_apikey: INTUIT_APIKEY,
  intuit_userid:
    window.__shellInternal?.applicationContext?.userAuthInfo?.authId || '',

  // Static values for now
  // intuit_token: '', // Get qbn.ptc.ticket cookie value in devportal-e2e.intuit.com

  // This will eventually be mapped on Interposer based on the intuit_userid
  csrf_token: CSRF_TOKEN,
  authorization_header_value: `Intuit_APIKey intuit_apikey=${INTUIT_APIKEY}, intuit_apikey_version=1.0`,
  incoming_host: 'mc-appfabricproxy-e2e.api.intuit.com',
} as const;
